import type { Employee } from "./types";

export const API_URL =
  process.env.REACT_APP_API_URL || "https://api.getnovala.com";

export const getToken = (): string =>
  localStorage.getItem("access_token") || localStorage.getItem("token") || "";

export const authHeaders = (): Record<string, string> => ({
  Authorization: "Bearer " + getToken(),
});

export const employeeName = (e: Employee): string => {
  const f = (e.first_name || "").trim();
  const l = (e.last_name || "").trim();
  if (l && f) return l + ", " + f;
  return e.full_name || e.name || e.email || "Unnamed";
};

export const shortAddress = (full: string | undefined | null): string => {
  if (!full) return "";
  const provMatch = full.match(/\b([A-Z]{2})\b/);
  const province = provMatch ? provMatch[1] : "";
  const street = full.split(",")[0].trim();
  return province ? street + " (" + province + ")" : street;
};